import { render, staticRenderFns } from "./Marks.vue?vue&type=template&id=00cdf802&scoped=true&"
import script from "./Marks.vue?vue&type=script&lang=js&"
export * from "./Marks.vue?vue&type=script&lang=js&"
import style0 from "./Marks.vue?vue&type=style&index=0&id=00cdf802&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cdf802",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VFlex,VLayout,VSkeletonLoader})
